module.exports = __webpack_public_path__ + "media/House of Mystery.6c0547cf.mp3";